<template>
  <v-container fluid>
    <v-form @submit="submit" onSubmit="return false;" id="distribution-form" v-model="valid" ref="form" class="wrapper lg mx-auto pa-4 mt-4">
      <v-layout>
        <v-flex v-if="!loading" class="table-container" lg12>
          <h2>Current GHA distrubtion cutoff: {{ cutoff }}</h2>
        </v-flex>
        <v-flex v-if="loading">
          <h2>Loading...</h2>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 pa-3>
          <v-text-field
            label="Adjust GHA distribution cutoff"
            v-model="updatedCutoff"
            placeholder="Cutoff in days"
            class="input-group--focused"
            type="number"
            :rules="[() => updatedCutoff && updatedCutoff > 0 || 'Distribution cutoff required']"
            required
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <div class="controls">
          <v-btn @click="submit" :disabled="!valid" color="success">submit</v-btn>
          <v-btn @click="clear">clear</v-btn>
        </div>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'DistributionForm',
  data() {
    return {
      success: false,
      error: false,
      valid: false,
      updatedCutoff: null
    };
  },
  computed: mapState({
    ...mapState('account', ['user']),
    ...mapState('distributionCutoff', ['cutoff', 'loading'])
  }),
  methods: {
    ...mapActions('distributionCutoff', ['getData', 'postData']),
    submit() {
      if (this.$refs.form.validate()) {
        this.postData({ cutoff: this.updatedCutoff, email: this.user.email });
      }
      this.getData();
    },
    clear() {
      this.$refs.form.reset();
    }
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss">
@import './../style/_variables.scss';

#distribution-form {
  background-color: $white;
}

.controls {
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributionForm.vue